import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RolePermissionsService } from '../services/role-permissions/role-permissions.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
  constructor(
    private rolePermissionsService: RolePermissionsService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const roleCode = route.data['roleCode'] as string;
    const permissionCode = route.data['permissionCode'] as string;

    if (!roleCode || !permissionCode) {
      this.router.navigate(['/not-found']);
      return of(false);
    }

    return this.rolePermissionsService.hasPermission(roleCode, permissionCode).pipe(
      map((hasPermission: boolean) => {
        if (!hasPermission) {
          this.router.navigate(['/not-found']);
          return false;
        }
        return true;
      }),
      catchError(() => {
        this.router.navigate(['/not-found']);
        return of(false);
      })
    );
  }
}